import React, { Component } from 'react';
import Slider from 'react-slick';
import '../../../node_modules/slick-carousel/slick/slick.css';
import '../../../node_modules/slick-carousel/slick/slick-theme.css';

const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
};

class GymOwners extends Component {
    constructor(props) {
        super(props);
        console.log('GymOwners constructor - ownersContent:', this.props.ownersContent);
    }
    
    componentDidMount() {
        console.log('GymOwners mounted - ownersContent:', this.props.ownersContent);
    }
    
    render() {
        const { ownersGallery, ownersTitle, ownersContent } = this.props;
        console.log('GymOwners render - ownersContent:', ownersContent);
        return (
            <>
                <section
                    className="page-section smallestwdt"
                    id="aboutsliderdiv"
                >
                    <div className="container">
                        <h2
                            className="bluetxt"
                            dangerouslySetInnerHTML={{
                                __html: ownersTitle,
                            }}
                            style={{ display: 'none' }}
                        ></h2> 
                        <div
                            dangerouslySetInnerHTML={{
                                __html: ownersContent,
                            }}
                        ></div>
                        <div className="carousel slide dots_about slider_owners">
                            <Slider {...settings} className="carousel-inner">
                                {ownersGallery.map(galleryImage => (
                                    <div
                                        className="item carousel-item"
                                        key={galleryImage.id}
                                    >
                                        <img
                                            className="margin-0 width_100"
                                            src={
                                                galleryImage.localFile
                                                    .childImageSharp.fluid.src
                                            }
                                            loading="lazy"
                                            alt="placeholder"
                                        />
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                </section>
            </>
        );
    }
}

export default GymOwners;
